"use client";

import Hero from "./components/Hero";
import Problem from "./components/Problem";
import Workflow from "./components/Workflow";
import Features from "./components/Features";
import MobileApp from "./components/MobileApp";
import ReportsShowcase from "./components/ReportsShowcase";
import Automation from "./components/Automation";
import Benefits from "./components/Benefits";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";

import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function OrquestiPage() {
  const [mounted, setMounted] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash) {
        return;
      }

      let attempts = 0;
      const maxAttempts = 30;

      const tryScroll = () => {
        const element = document.getElementById(hash.slice(1));
        if (element) {
          window.requestAnimationFrame(() => {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          });
          return;
        }

        if (attempts < maxAttempts) {
          attempts += 1;
          window.requestAnimationFrame(tryScroll);
        }
      };

      window.requestAnimationFrame(tryScroll);
    };

    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);

    return () => {
      window.removeEventListener("hashchange", scrollToHash);
    };
  }, []);

  // Listen for CTA click from header - redirige a la página de coming soon
  useEffect(() => {
    const handleCTAClick = () => {
      router.push("/coming-soon");
    };
    window.addEventListener("website-cta-click", handleCTAClick);
    return () => {
      window.removeEventListener("website-cta-click", handleCTAClick);
    };
  }, [router]);

  // Durante la hidratación, mostrar nada para evitar mismatch
  if (!mounted) {
    return null;
  }

  // En producción, mostrar "En construcción"
  // if (isProduction) {
  //   return (
  //     <div className="flex items-center justify-center h-dvh bg-[hsl(221,51%,16%)] text-white">
  //       <div className="text-center space-y-4">
  //         <h1 className="text-4xl font-bold">En construcción</h1>
  //         <p className="text-slate-400">
  //           Estamos trabajando en algo increíble. Vuelve pronto.
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }

  // const testimonials = [
  //   {
  //     quote:
  //       "Reducimos el tiempo de programación de turnos en un 80%. Ahora nuestro equipo está más satisfecho y tenemos menos errores.",
  //     author: "Dr. María González",
  //     role: "Directora de Operaciones, Hospital San Juan",
  //     avatar: "/female-doctor-headshot.png",
  //   },
  //   {
  //     quote:
  //       "La mejor inversión que hemos hecho. El sistema de intercambio de turnos ha mejorado la flexibilidad de nuestro personal.",
  //     author: "Carlos Méndez",
  //     role: "Gerente de RRHH, Clínica Salud Total",
  //     avatar: "/male-healthcare-manager-professional-headshot.jpg",
  //   },
  //   {
  //     quote:
  //       "Cumplimiento normativo automático y reportes en tiempo real. Ya no nos preocupamos por auditorías de RRHH.",
  //     author: "Dra. Ana Ruiz",
  //     role: "Jefa de Enfermería, Centro Médico Norte",
  //     avatar: "/female-nurse-professional-headshot.jpg",
  //   },
  // ];

  return (
    <>
      <Hero />
      <Problem />
      <Workflow />
      <Features />
      <MobileApp />
      <ReportsShowcase />
      <Automation />
      <Benefits />
      {/* <Industries /> */}
      <FAQ />
      <FinalCTA />
    </>
  );
}
